<template>
  <div class="custom-mgmt-placeholder">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>自定义报表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-alert title="该菜单尚未接入具体页面" type="info" :closable="false" show-icon>
      <p>路由与入口已打通。若需业务页面，请在 <code>src/views/businessMgmt/CustomMgmt.vue</code> 中实现或改为跳转到实际报表地址。</p>
    </el-alert>
  </div>
</template>

<script>
export default {
  name: "CustomMgmt",
};
</script>

<style lang="scss" scoped>
.custom-mgmt-placeholder {
  padding: 20px;
  background: #fff;
  min-height: 400px;
}
.breadcrumb-box {
  margin-bottom: 16px;
}
</style>
